import { trackFunnel } from "@/libs/analytics";
import { FREE_PFP_TOOL_ID } from "./freePfpExport";
import type { LandingDemoId } from "@/libs/landingHandoff";

export const FREE_PFP_OPENED_EVENT = "acquisition_free_pfp_opened";
export const FREE_PFP_READY_EVENT = "acquisition_free_pfp_ready";
export const FREE_PFP_POLL_FAILED_EVENT = "acquisition_free_pfp_poll_failed";
export const FREE_PFP_DOWNLOADED_EVENT = "tool_engagement_free_pfp_downloaded";
export const FREE_PFP_REUPLOAD_EVENT = "tool_engagement_free_pfp_photo_uploaded";
export const FREE_PFP_GATE_SHOWN_EVENT = "acquisition_free_pfp_gate_shown";
export const FREE_PFP_GATE_AUTH_STARTED_EVENT = "acquisition_free_pfp_gate_auth_started";
export const FREE_PFP_GATE_AUTH_COMPLETED_EVENT = "acquisition_free_pfp_gate_auth_completed";
export const FREE_PFP_DOWNLOAD_DELIVERED_EVENT = "acquisition_free_pfp_download_delivered";

export type FreePfpHandoffSource = "demo" | "upload" | "fallback" | "in_app";

function props(extra: Record<string, unknown>) {
  return { tool_id: FREE_PFP_TOOL_ID, ...extra };
}

export function trackFreePfpOpened(opts: {
  source: FreePfpHandoffSource;
  demoId?: LandingDemoId | null;
  ppUid?: string | null;
}) {
  trackFunnel(
    "acquisition",
    "free_pfp_opened",
    props({
      handoff_source: opts.source,
      demo_id: opts.demoId ?? null,
      has_pp_uid: Boolean(opts.ppUid),
    })
  );
}

export function trackFreePfpReady(opts: {
  source: FreePfpHandoffSource;
  demoId?: LandingDemoId | null;
  defaultCutout?: boolean;
}) {
  trackFunnel(
    "acquisition",
    "free_pfp_ready",
    props({
      handoff_source: opts.source,
      demo_id: opts.demoId ?? null,
      default_cutout: Boolean(opts.defaultCutout),
    })
  );
}

export function trackFreePfpPollFailed(opts: { error?: string | null }) {
  trackFunnel(
    "acquisition",
    "free_pfp_poll_failed",
    props({
      handoff_source: "upload",
      error: opts.error ? String(opts.error).slice(0, 160) : null,
    })
  );
}

export function trackFreePfpDownloaded(opts: { source: FreePfpHandoffSource | "in_app" }) {
  trackFunnel(
    "tool_engagement",
    "free_pfp_downloaded",
    props({ handoff_source: opts.source })
  );
}

export function trackFreePfpReupload(opts: { ok: boolean; error?: string | null }) {
  trackFunnel(
    "tool_engagement",
    opts.ok ? "free_pfp_photo_uploaded" : "free_pfp_photo_upload_failed",
    props({
      error: opts.error ? String(opts.error).slice(0, 160) : null,
    })
  );
}

export function trackFreePfpGateShown() {
  trackFunnel("acquisition", "free_pfp_gate_shown", props({}));
}

export function trackFreePfpGateAuthStarted(opts: { method: "google" | "email" }) {
  trackFunnel(
    "acquisition",
    "free_pfp_gate_auth_started",
    props({ auth_method: opts.method })
  );
}

export function trackFreePfpGateAuthCompleted() {
  trackFunnel("acquisition", "free_pfp_gate_auth_completed", props({}));
}

export function trackFreePfpDownloadDelivered(opts: {
  source: FreePfpHandoffSource | "in_app";
  afterGate: boolean;
}) {
  trackFunnel(
    "acquisition",
    "free_pfp_download_delivered",
    props({
      handoff_source: opts.source,
      after_gate: opts.afterGate,
    })
  );
}
